<template>
  <div id="product">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>Product List</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="padding-right:46%;">
        <el-button class="button" type="primary" @click="addProduct" :style="buttonStyle">Add New</el-button>
      </div>
    </div>
    <ul class="cards">
      <div class="noData" v-if="productList.length <= 0 ">You have not uploaded product information</div>
      <li v-for="(val) in productList" :key="val.id">
        <div :body-style="{ padding: '0px' }" class="cardItem">
          <div class="img"><img :src="val.productImg"></div>
          <div class="rightBox">
            <!-- <h3>公司名： {{val.clgComName}}</h3> -->
            <!-- <h3>Product Name： {{val.pdtName}}</h3> -->
            <h3>Product Name： {{val.pdtEName}}</h3>
            <p>Booth Number： <span class="blue">{{ userInfo.bthCode || 'Currently unavailable' }}</span></p>
            <!-- <div class="text">Product Description： {{val.pdtIntro}}</div> -->
            <div class="text">Product Description： {{val.pdtEIntro}}</div>
            <div class="bottom clearfix">
              <el-button class="button" :style="buttonStyle" size="medium" type="primary" @click="edit(val)">Modify</el-button>
              <el-button class="button" size="medium" @click="del(val)">Delete</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div style="text-align:center;padding:10px 0">
      <el-pagination
        @current-change = 'pageChange'
        :page-size="10"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  name: 'Product',
  data() {
    return {
      productList:[],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      PageSize: '10', // 分页  当前页数量
      PageIndex: '1', // 分页  页数
      total: 0, // 分页  总数量
    }
  },
  mounted() {
    this.isPC = tools.isPC()
    this.getList()
  },
  methods: {
    pageChange(page){
      this.PageIndex = page.toString()
      this.getList()
    },
    handleSelectionChange(val){
      this.selectData = val
      this.getList()
    },
    addProduct() {
      // this.$router.push('/addProduct')
      api.GetPdtInfoDetail().then((res)=>{
        // console.log(res,'GetPdtInfoDetail')
        if(res.data.code =='200' && res.data.data){
          if (res.data.data.pdtNames.length > 0 || res.data.data.pdtENames.length > 0) {
            this.$router.push('/addProduct')
          } else {
            this.$notify({
              title: 'Tip',
              message: 'Please complete the main product first.',
              type: 'error'
            });
          }
        }
      })
    },
    edit(val){
      this.$router.push({path: '/addProduct', query: {id: val.id}});
    },
    //获取数据
    getList(){
      api.productlist({
        pageIndex:"0"
      }).then((res)=>{
        if(res.data.code =='200'){
          var _data = res.data.data
          this.productList = _data.list
          this.total = _data.total
        }
      })
    },
    del(val){
        this.$confirm('Confirm to delete this product？', 'Tip', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          api.deleteproduct({pdtID: parseInt(val.id) }).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: 'success',
                message: 'Delete successfully',
                type: 'success'
              });
              this.getList()
            }
          })
        }).catch(() => {});
    }
  }
}
</script>
<style lang="less" scoped>
.noData{
  text-align: center;
  width: 100%;
  font-size: 16px;
  color:#999
}
#product{
  padding-top:30px;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
    .text{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    padding-top:30px;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:90px;
        height: auto;
        background: #fff;
        img{
          max-width: 90px;
        }
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      h3{
        font-size: 14px;
      }
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px
      }
    }
  }
}
</style>
